import { FormattedMessage } from 'react-intl'

import { MeditateIcon, HeartIcon, FlowerIcon, EyeIcon, CursorIcon, ArrowForwardIcon } from 'Icons'

export default function InfoBlock() {
  return (
    <div className="flex flex-col items-center gap-1.5 p-3 md:gap-4 md:p-4">
      {/* eslint-disable-next-line max-len */}
      <h1 className="bg-linear-to-r from-fuchsia-500 via-violet-500 to-indigo-500 bg-clip-text text-2xl font-extrabold tracking-tight text-transparent md:hidden">
        <FormattedMessage id="header.title" defaultMessage="Emotion Wheel" />
      </h1>
      <h2 className="px-6 text-center text-xl font-semibold md:text-2xl lg:text-3xl">
        <FormattedMessage id="infoBlock.title" defaultMessage="Feel. Understand. Choose" />
      </h2>
      <h3 className="px-6 text-center text-lg md:text-xl lg:text-2xl">
        <FormattedMessage
          id="infoBlock.subtitle"
          defaultMessage="Discover what you feel, find your balance, and take charge of your day"
        />
      </h3>
      <ActionSteps />
    </div>
  )
}

function ActionSteps() {
  return (
    <>
      <div className="hidden h-1 lg:block" />
      <div className="hidden flex-row gap-1 md:flex lg:gap-1.5">
        <Card
          title={<FormattedMessage id="actionSteps.step1.title" defaultMessage="Pause & Breathe" />}
          icon={<MeditateIcon />}
        >
          <FormattedMessage
            id="actionSteps.step1.subtitle"
            defaultMessage="Take a moment. Notice what you’re feeling"
          />
        </Card>
        <StepIcon />
        <Card
          title={
            <FormattedMessage id="actionSteps.step2.title" defaultMessage="Choose Your Base" />
          }
          icon={<HeartIcon />}
        >
          <FormattedMessage
            id="actionSteps.step2.subtitle"
            defaultMessage="Start at the center of Feelings Wheel"
          />
        </Card>
        <StepIcon />
        <Card
          title={<FormattedMessage id="actionSteps.step3.title" defaultMessage="Find Your Shade" />}
          icon={<CursorIcon />}
        >
          <FormattedMessage
            id="actionSteps.step3.subtitle"
            defaultMessage="Move outward to find the precise feeling"
          />
        </Card>
        <StepIcon />
        <Card
          title={<FormattedMessage id="actionSteps.step4.title" defaultMessage="Reflect" />}
          icon={<EyeIcon />}
        >
          <FormattedMessage
            id="actionSteps.step4.subtitle"
            defaultMessage="What triggered it? What do you need?"
          />
        </Card>
        <StepIcon />
        <Card
          title={<FormattedMessage id="actionSteps.step5.title" defaultMessage="Act Mindfully" />}
          icon={<FlowerIcon />}
        >
          <FormattedMessage
            id="actionSteps.step5.subtitle"
            defaultMessage="Even a small step matters"
          />
        </Card>
      </div>
    </>
  )
}

function StepIcon() {
  return (
    <div className="flex items-center justify-center opacity-80">
      <ArrowForwardIcon />
    </div>
  )
}

type CardProps = {
  title: React.ReactNode
  children: React.ReactNode
  icon?: React.ReactNode
}

function Card({ title, children, icon }: CardProps) {
  return (
    <div className="card card-xs lg:card-sm xl:card-md flex-1 bg-violet-300/30 shadow-sm">
      <div className="card-body items-center text-center">
        {icon}
        <h2 className="card-title">{title}</h2>
        <p className="card-body p-0">{children}</p>
      </div>
    </div>
  )
}
